import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

import {BrowserRouter} from "react-router-dom"
import {ToastContainer} from "react-toastify"

import './index.css';
import './styles/scss/style.scss'

import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter 
      basename='/eventos'
    >
      <ToastContainer />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
